var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('navbar'),_c('hero'),_c('features'),_c('weddings'),_c('about-us'),_c('live-social'),_c('who-we-are'),_c('partners'),_c('band'),_c('contact'),_c('whats-app-cta')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }